import { Space, Text, TextButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { ConversationOrderSummarySection } from './ConversationOrderSummarySection'
import messages from './messages'
import { ConversationOrderSummaryValueStyled } from './styles/ConversationOrderSummaryValueStyled'
import { type ConversationCartPaymentMethod } from '../../value-objects/ConversationTurnItem'

export interface IConversationCheckoutOrderSummaryPaymentMethodProps {
  paymentMethod: ConversationCartPaymentMethod
  disabled?: boolean
  onSendMessage: (message: string) => void
}

export const ConversationCheckoutOrderSummaryPaymentMethod = ({
  paymentMethod,
  disabled,
  onSendMessage,
}: IConversationCheckoutOrderSummaryPaymentMethodProps) => {
  const intl = useProcurifyIntl()
  const label = intl.formatMessage(messages.paymentMethod)
  const changeText =
    paymentMethod.changeAction?.text ??
    intl.formatMessage(messages.changePaymentMethod)

  const handleChange = () => {
    onSendMessage(paymentMethod.changeAction?.message ?? changeText)
  }

  return (
    <ConversationOrderSummarySection
      ariaLabel={label}
      isCollapsible={false}
      title={
        <Space direction='horizontal' justify='space-between' align='center'>
          <Space direction='horizontal' size='medium' align='center'>
            <Text inline color='textSecondary'>
              {label}
            </Text>
            <ConversationOrderSummaryValueStyled>
              {paymentMethod.label}
            </ConversationOrderSummaryValueStyled>
          </Space>
          <TextButton
            analyticsId='conversation-change-payment-method-button'
            disabled={disabled}
            onClick={handleChange}
          >
            {changeText}
          </TextButton>
        </Space>
      }
    />
  )
}
